import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { TAXONOMY, HELP_TEXTS } from '../constants';

export default function TierBadge({ tier, sx }) {
  const cfg = TAXONOMY.tiers[String(tier || '').toLowerCase()] || TAXONOMY.tiers.standard;
  const isPlatinum = cfg.id === 'Platinum';
  const help = HELP_TEXTS.platinum_client;
  return (
    <Tooltip title={isPlatinum ? `${help.title}: ${help.body}` : ''} arrow placement="top">
      <Chip
        size="small"
        label={`${cfg.icon || ''} ${cfg.label}`.trim()}
        sx={{
          fontSize: 10.5,
          fontWeight: 600,
          height: 22,
          bgcolor: (t) =>
            isPlatinum ? alpha(t.palette.secondary.main, 0.12) : alpha(t.palette.grey[500], 0.12),
          color: (t) => (isPlatinum ? t.palette.secondary.dark : t.palette.text.secondary),
          border: (t) =>
            `1px solid ${
              isPlatinum ? alpha(t.palette.secondary.main, 0.35) : alpha(t.palette.grey[500], 0.32)
            }`,
          '& .MuiChip-label': { px: 0.75 },
          ...sx,
        }}
      />
    </Tooltip>
  );
}
